module.exports = __webpack_public_path__ + "img/png05.b5c55b9c.png";